import { getXmlValueFE } from './getXmlValueFE';
import store from "@/store"

export function conditionalBlockTrue(childId, data){
    const rule = data.props.rules.find(r => r.conditionalBlock === childId);
    const statement = data.props?.rules[data.props.previewIndex].statement
    const xPath = (statement) ? store.state.xPathPlaceholders.find(p => p.placeholder === statement)?.xpath : null
    const dataStatementValue = getXmlValueFE(xPath) //value of key "statement" in example customer data
    const value = rule.value
    const operator = rule.operator
    if (!rule.fullCondition || rule.fullCondition == `${statement}${operator}${value}`){
    switch (operator){
        case '==':
        case '=': //in case of user mistake
          return dataStatementValue == value;
        case '<':
          return dataStatementValue < value;
        case '>':
          return dataStatementValue > value;
        case '!=':
          return dataStatementValue !== value;
        case 'else':
          return false
    }} else {
      return eval(rule.fullCondition) //could or should be replaced with a better, faster and safer alternative. In case only admins have access.
    }
  }